import { render } from "./ForbiddenProvidersView.vue?vue&type=template&id=99d33914&scoped=true"
import script from "./ForbiddenProvidersView.vue?vue&type=script&lang=js"
export * from "./ForbiddenProvidersView.vue?vue&type=script&lang=js"

import "./ForbiddenProvidersView.vue?vue&type=style&index=0&id=99d33914&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d33914"]])

export default __exports__